// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"7ea258bb","171":"eace0a3a","507":"93abd1fe","617":"fbf58908","801":"bb19c22d"}[chunkId] + ".chunk.js";
};